export function LockIcon() {
  return (
    <svg width="47" height="53" viewBox="0 0 47 53" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M40.75 18H37.875V13C37.875 6.1 31.435 0.5 23.5 0.5C15.565 0.5 9.125 6.1 9.125 13V18H6.25C3.0875 18 0.5 20.25 0.5 23V48C0.5 50.75 3.0875 53 6.25 53H40.75C43.9125 53 46.5 50.75 46.5 48V23C46.5 20.25 43.9125 18 40.75 18ZM23.5 40.5C20.3375 40.5 17.75 38.25 17.75 35.5C17.75 32.75 20.3375 30.5 23.5 30.5C26.6625 30.5 29.25 32.75 29.25 35.5C29.25 38.25 26.6625 40.5 23.5 40.5ZM32.4125 18H14.5875V13C14.5875 8.725 18.5837 5.25 23.5 5.25C28.4163 5.25 32.4125 8.725 32.4125 13V18Z"
        fill="black" />
    </svg>
  );
}